// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ClientQuoteCard({ name, review }) {
  return (
    <MKBox bgColor="surface" borderRadius="xl" shadow="md" p={2.5} height="100%">
      <MKTypography variant="body2" color="text" mb={1.5}>
        &quot;{review}&quot;
      </MKTypography>
      <MKTypography variant="button" fontWeight="bold" color="dark">
        {name}
      </MKTypography>
    </MKBox>
  );
}

ClientQuoteCard.propTypes = {
  name: PropTypes.string.isRequired,
  review: PropTypes.string.isRequired,
};

export default ClientQuoteCard;
